RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const SocialPresencesCell = Marionette.ItemView.extend({
        tagName: 'td',

        template: '#socialPresencesCellTemplate',

        getPresenceHandle: function (source, presenceData, trendKey) {
            const me = this;

            const companyDisplay = RivalIQ.utils.companyDisplay;
            const sources = RivalIQ.enums.sources;
            const fns = {
                [sources.TWITTER]: companyDisplay.getTwitterDecoratedHandle,
                [sources.INSTAGRAM]: companyDisplay.getInstagramDecoratedHandle,
                [sources.TIKTOK]: companyDisplay.getTiktokDecoratedHandle,
                [sources.FACEBOOK]: companyDisplay.getFacebookDecoratedHandle
            };

            return (fns[source] ? fns[source](presenceData) : me.getChannelHandle(presenceData, trendKey));
        },

        getChannelHandle: function (presenceData, trendKey) {
            const presence = _.get(presenceData, ['periodSummary', trendKey, 0, 'presence']);
            if (!presence) {
                return;
            }

            return presence.display_name || presence.handle || presence.title || presence.native_id;
        },

        serializeData: function () {
            const me = this;

            const data = me.model.get('data');
            const presences = _.reduce(data.socialPresences, (memo, data, channel) => {
                if (!_.isNull(data)) {
                    const channelData = RivalIQ.data.channels.get(channel);
                    const source = channelData.get('source');
                    const trendKey = channelData.get('trendKey');
                    const companyData = _.set({}, [
                        'periodSummary',
                        trendKey,
                        0,
                        'presence',
                        'handle'
                    ], data.handle);
                    if (data.native_id) {
                        _.set(companyData, [
                            'periodSummary',
                            trendKey,
                            0,
                            'presence',
                            'native_id'
                        ], data.native_id);
                    }
                    const handle = me.getPresenceHandle(source, companyData, trendKey);
                    const sourceLink = RivalIQ.utils.companyDisplay.getSourceLink(source, companyData, true);

                    memo.push({
                        fontIcon: channelData.get('fontIcon'),
                        url: sourceLink,
                        handle: handle
                    });
                }
                return memo;
            }, []);

            return {
                presences
            };
        }
    });

    const LinkCell = Marionette.ItemView.extend({
        className: 'wrap-break-word',

        tagName: 'td',

        template: '#linkCellTemplate',

        getCompanyUrlText: function (data) {
            return (data.company_url || '').replace(/https?:\/\/(www\.)?/, '').replace(/\/$/, '');
        },

        serializeData: function () {
            const me = this;

            const data = me.model.get('data');
            const companyLinkText = me.getCompanyUrlText(data);
            return {
                linkText: companyLinkText,
                link: data.company_url
            };
        }
    });

    const ListCell = Marionette.ItemView.extend({
        tagName: 'td',

        template: '#listCellTemplate',

        serializeData: function () {
            const me = this;

            const data = me.model.get('data');
            return {
                data: data.landscapes
            };
        }
    });

    const tableConfig = {
        className: 'table table-double-header account-companies-table',
        columns: [
            {
                name: 'Company Name',
                cellClassName: 'cell-middle',
                sort: 'company_name',
                sortKey: 'company_name',
                value: function (model) {
                    return model.company_name;
                }
            },
            {
                name: 'Landscape Name(s)',
                sort: 'first_landscape_name',
                sortKey: 'first_landscape_name',
                cellClassName: 'cell-middle',
                cellView: ListCell
            },
            {
                name: 'Company URL',
                sort: 'company_url',
                sortKey: 'company_url',
                cellClassName: 'cell-middle',
                cellView: LinkCell
            },
            {
                name: 'Social Profiles',
                cellClassName: 'cell-middle',
                cellView: SocialPresencesCell
            }
        ]
    };

    views.AccountCompanies = RivalIQ.views.LoadingTableView.mixin({
        config: tableConfig,
        className: 'table-responsive',
        sortBy: 'company_name',
        sortUsageMetric: null,
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        emptyView: Marionette.ItemView.extend({
            template: '#accountCompaniesEmptyViewTemplate'
        }),

        loadData: function (callback) {
            const me = this;

            me.account = RivalIQ.state.account;
            $.when(
                me.account.getAllCompanies()
            ).done(function (companies) {
                const companyRows = _(companies).chain()
                    .reduce((memo, company) => {
                        const companyId = company.company_id;
                        const companyEntry = _.find(memo, {
                            company_id: companyId
                        });
                        if (companyEntry) {
                            // build landscape array sorted by name
                            const sortedIndex = _.sortedIndex(companyEntry.landscapes, company.landscape_name);
                            companyEntry.landscapes.splice(sortedIndex, 0, company.landscape_name);
                            companyEntry.first_landscape_name = _.head(companyEntry.landscapes);
                        } else {
                            const companyData = _.omit(company, 'landscape_name');
                            companyData.landscapes = [].concat(company.landscape_name);
                            companyData.first_landscape_name = company.landscape_name;
                            memo.push(companyData);
                        }
                        return memo;
                    }, [])
                    .sortBy(me.sortBy)
                    .value();

                me.model = new Backbone.Model({
                    data: companyRows
                });
                callback();
            });
        }
    });

    const CompanyUsageModal = Marionette.LayoutView.extend({
        template: '#companyUsageModalTemplate'
    });

    views.CompanySummary = RivalIQ.views.ItemView.extend({
        className: 'panel-body',
        template: '#companyUsageTemplate',

        ui: {
            popover: '[data-toggle="popover"]'
        },

        events: {
            'click .x-add-more-companies': 'onOpenAddCompaniesModal',
            'click .x-view-company-usage': 'onViewCompanyUsageModal',
            'click .x-trigger-intercom': 'showIntercom'

        },

        showIntercom: function () {
            if (window.Intercom) {
                window.Intercom('show');
            }
        },

        onRender: function () {
            const me = this;

            me.ui.popover.popover();
        },

        onOpenAddCompaniesModal: function () {
            RivalIQ.execute('show:modal', new RivalIQ.landscape.views.AddCompaniesModal({
                model: new Backbone.Model({
                    showAddCompanyModal: false,
                    credits: RivalIQ.state.account.get('companyLimits'),
                    reloadOnSuccess: true,
                    page: 'company usage'
                })
            }));
        },

        onViewCompanyUsageModal: function () {
            RivalIQ.execute('show:modal', new CompanyUsageModal());
        },

        modelEvents: {
            'change:companyLimits': 'onCompanyLimitsChanged'
        },

        onCompanyLimitsChanged: function () {
            const me = this;

            me.reload();
        },

        serializeData: function () {
            //- NOTE: This logic is duplicated in mixins/subscription.jade, if you update it here update it there too.

            const isInNBQCustomerGroup = RivalIQ.state.account.get('isInNBQCustomerGroup');
            const companyLimits = RivalIQ.state.account.get('companyLimits');
            const isPaid = RivalIQ.state.account.get('accountConversionStatus') === RivalIQ.enums.account.conversionStatus.PAID;
            // NOTE user can self-serve add more companies if paid, and either annual or monthly and below a threshold
            const MAX_COMPANIES_FOR_SELF_SERVE = 55;
            const canUpsellCompanies = isPaid && (companyLimits.plan < MAX_COMPANIES_FOR_SELF_SERVE) && !isInNBQCustomerGroup;

            const csm = RivalIQ.state.account.get('csm');
            const csmAlias = RivalIQ.enums.csmDetails[csm?.Name]?.alias || 'support';

            return {
                companyCredits: companyLimits,
                resetDate: RivalIQ.state.account.get('resetAt'),
                landscapes: RivalIQ.state.user.get('landscapes'),
                canUpsellCompanies: canUpsellCompanies,
                isInNBQCustomerGroup: isInNBQCustomerGroup,
                csmEmail: `${csmAlias}@rivaliq.com`,
                isPaid: isPaid,
                enforceCompanyPlanLimit: RivalIQ.state.account.get('enforceCompanyPlanLimit')
            };
        }
    });
});
